import React, { createContext, useEffect, useState } from 'react'
import {ReactComponent as BusIcon} from '../images/icon_bus.svg'
import {ReactComponent as TaxiIcon} from '../images/icon_taxi.svg'
import {ReactComponent as EvtolIcon} from '../images/icon_evtol.svg'

export const AppContext = createContext()

const AppContextProvider = (props) => {

  const [tripDetails, setTripDetails] = useState({
      location: "Umeå",
      destination: "Stockholm",
      travellers: 1, 
      date: null,
      booker: "",
      passengers: [],
      priceFrom: "",
      priceTo: "",
      priceFlexRed: -100,
      priceFillRed: -200,
      depFrom: "00:00",
      depTo: "22:59",
      arrFrom: "01:00",
      arrTo: "23:59"
  })

  const [geoAddress, setGeoAddress] = useState()
  const [prevPage, setPrevPage] = useState("/");
  const [nextPage, setNextPage] = useState("/");
  const [infoShow, setInfoShow] = useState(false)
  const [preBookedSeats, setPreBookedSeats] = useState([])
  const [closestAirports, setClosestAirports] = useState({
    from: null,
    to: null
  })

  const [commuteOptions, setCommuteOptions] = useState({
    from: null,
    to: null
  })

  useEffect(() => {
    const tripDetailsJSON = localStorage.getItem('tripDetails')
    if (tripDetailsJSON) {
      const result = JSON.parse(tripDetailsJSON)
      console.log(result)
      setTripDetails(result)
      setGeoAddress(result.location)
    } else {
      setGeoAddress('Umeå flygplats')
    }
    const closestAirportsJSON = localStorage.getItem('closestAirports')
    if (closestAirportsJSON) {
      const result = JSON.parse(closestAirportsJSON)
      console.log(result)
      setClosestAirports(result)
    }
  }, [])

//   function CommuteFromIcon() {
       
//     if (commuteOptions.from == 'commute-bus') {
//           return <BusIcon />
//     } else if (commuteOptions.from == 'commute-taxi') {
//      return <TaxiIcon />
//      } else if (commuteOptions.from == 'commute-evtol') {
//          return <EvtolIcon />
//      } else {
//          return ""
//      }
//  }



  useEffect(() => {console.log(geoAddress)}, [geoAddress])

  useEffect(() => {
    if (tripDetails) {
      const json = JSON.stringify(tripDetails)
      localStorage.setItem('tripDetails', json)
    }
  }, [tripDetails])

  useEffect(() => {
    const json = JSON.stringify(closestAirports)
    localStorage.setItem('closestAirports', json)
    console.log('these are the closest airports', closestAirports)
  }, [closestAirports])

  return (
    <AppContext.Provider value={{
      tripDetails, setTripDetails,
      prevPage, setPrevPage,
      nextPage, setNextPage,
      infoShow, setInfoShow,
      geoAddress, setGeoAddress,
      preBookedSeats,setPreBookedSeats,
      commuteOptions, setCommuteOptions,
      closestAirports,setClosestAirports}}>
      {props.children}
    </AppContext.Provider>
  )
}

export default AppContextProvider